<template>
  <button
    v-bind="$attrs"
    v-on="$listeners"
    class="button"
    :class="{
      'stretch': stretch,
    }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'OButton',

  props: {
    stretch: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.button {
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  color: white;
  background: #154fb7;
  border: 1px solid white;
  box-shadow: 2px 2px 4px #00000078;
}

.button:disabled {
  background: #154fb775;
}

.stretch {
  margin: 0;
  border-radius: 0;
  width: 100%;
  padding: 10px 10px;
  box-shadow: 0 0 0;
  border: 0;
  border-top: 4px solid white;
}
</style>
